import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

const ModalHeader3 = (props) => (
  <Modal.Header
    className={props.className}
    closeButton
    onHide={() => {
      props.onClose()
    }}
  >
    {props.children}
  </Modal.Header>
)

ModalHeader3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

ModalHeader3.defaultProps = {
  className: '',
  onClose: () => {}
}

export default ModalHeader3
